import { useCallback, useState, useRef } from "react";
import PropTypes from "prop-types";
import ResizeObserver from "resize-observer-polyfill";

export const useMeasure = () => {
	const [ measured, setMeasured ] = useState({});
	const [ lastMeasuredNode, setLastMeasuredNode ] = useState(null);
	const resizeObserverRef = useRef(new ResizeObserver(([{ contentRect }]) => {
		setMeasured({
			height: contentRect.height,
			width: contentRect.width,
			x: contentRect.x,
			y: contentRect.y,
			top: contentRect.top,
			left: contentRect.left,
			right: contentRect.right,
			bottom: contentRect.bottom,
		});
	}));
	const ref = useCallback((measuredNode) => {
		const ro = resizeObserverRef.current;

		// Stop observing the last node.
		if (lastMeasuredNode) {
			ro.unobserve(lastMeasuredNode);
		}

		// Start observing this node.
		if (measuredNode) {
			ro.observe(measuredNode);
		}

		// Remember it for later.
		setLastMeasuredNode(measuredNode);
	}, [lastMeasuredNode]);

	return [ ref, measured ];
};

export default function Measured({ children }) {
	const [ ref, measured ] = useMeasure();
	return (
		children({
			ref,
			measured,
		})
	);
}

Measured.propTypes = {
	children: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/shared/components/Measured/index.js